import { render, staticRenderFns } from "./Settle2.vue?vue&type=template&id=0d88ae64&scoped=true&"
import script from "./Settle2.vue?vue&type=script&lang=js&"
export * from "./Settle2.vue?vue&type=script&lang=js&"
import style0 from "./Settle2.vue?vue&type=style&index=0&id=0d88ae64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d88ae64",
  null
  
)

export default component.exports